<template>
  <div class="calcFilter">
    <div class="calcFilter__section calcFilterForm">
      <gl-field-input
        v-model="budget"
        :label="$t('Your Budget')"
        class="calcFilterForm__formGroup calcFilterForm__formGroup--auto"
      />
      <gl-field-input
        v-model="rate"
        disabled
        :label="$t('ULTIMA Price')"
        class="calcFilterForm__formGroup calcFilterForm__formGroup--auto"
      />
      <gl-field-select
        v-model="license"
        :options="$store.getters.licenseAll"
        :label="$t('License')"
        class="calcFilterForm__formGroup calcFilterForm__formGroup--auto"
      />
      <gl-field-input
        v-model="inFreezing"
        disabled
        :label="$t('In Freezing')"
        class="calcFilterForm__formGroup calcFilterForm__formGroup--auto"
      />
      <gl-field-input
        v-model="total"
        disabled
        :label="$t('Total')"
        class="calcFilterForm__formGroup"
      />
      <div class="calcFilterForm__formGroup calcFilterForm__formGroup--slider">
        <gl-field :label="$t('In Freezing')" class="freezing">
          <template #default="{ innerId }">
            <p class="freezing__value">{{ freezing }} ULTIMA</p>
            <vue-range-slider
              :id="innerId"
              v-model="freezing"
              :key="$i18n.locale"
              :tooltip="false"
              :step="0.0001"
              :max="$store.getters.availableMaxLoad"
            />
          </template>
        </gl-field>
      </div>
      <gl-field-select
        v-model="startCourse"
        :options="$store.state.startCourseAll"
        :label="$t('MAX Load Index')"
        class="calcFilterForm__formGroup calcFilterForm__formGroup--auto"
      />
      <gl-field-select
        v-model="availableMaxLoad"
        :options="$store.getters.availableMaxLoadAll"
        :label="$t('Available Max Load')"
        class="calcFilterForm__formGroup calcFilterForm__formGroup--auto"
      />
      <gl-field-select
        v-model="freezeMonth"
        :options="freezeMonthAll"
        :label="$t('Freeze Month')"
        class="calcFilterForm__formGroup calcFilterForm__formGroup--auto"
      />
      <gl-field-input
        v-model="endCourse"
        :label="$t('End rate')"
        symbol="EUR"
        type="number"
        class="calcFilterForm__formGroup calcFilterForm__formGroup--auto"
      />
    </div>

    <div class="calcFilter__section calcFilterIncome">
      <div class="calcFilterIncome__title">
        <p class="textW--primary">{{ $t("Minting ULTIMA") }} /&#160;</p>
        <br class="calcFilterIncome__delimiter" />
        <p>{{ $t("Course ULTIMA") }} = {{ $store.state.endCourse }} EUR</p>
      </div>
      <div class="calcFilterIncome__row">
        <p class="textW--primary">
          {{ mintingCalendar.day.ULTIMA }} ULTIMA /&#160;
        </p>
        {{ $t("Day") }} &ndash; {{ mintingCalendar.day.EUR }} EUR
      </div>
      <div class="calcFilterIncome__row">
        <p class="textW--primary">
          {{ mintingCalendar.month.ULTIMA }} ULTIMA /&#160;
        </p>
        {{ $t("Month") }} &ndash; {{ mintingCalendar.month.EUR }} EUR
      </div>
      <div class="calcFilterIncome__row">
        <p class="textW--primary">
          {{ mintingCalendar.year.ULTIMA }} ULTIMA /&#160;
        </p>
        {{ $t("Year") }} &ndash; {{ mintingCalendar.year.EUR }} EUR
      </div>
    </div>
    <calc-tabs class="calcFilter__section" />
  </div>
</template>

<script>
import GlFieldSelect from "@gl/GlFieldSelect";

import CalcTabs from "@/components/Calc/CalcTabs";
import GlField from "@gl/GlField";
import GlFieldInput from "@gl/GlFieldInput";
import "vue-range-component-fixed/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component-fixed";

// eslint-disable-next-line no-unused-vars
function addEvent(el, type, fn, capture) {
  el.addEventListener(type, fn, {
    passive: false,
    capture: !!capture,
  });
}

export default {
  name: "CalcFilter",
  components: {
    GlField,
    GlFieldInput,
    CalcTabs,
    GlFieldSelect,
    VueRangeSlider,
  },
  data() {
    return {};
  },
  computed: {
    rate() {
      return this.$store.state.rate + " EUR";
    },

    inFreezing() {
      return (
        Number.parseFloat(
          (this.$store.state.freezing * this.$store.state.rate).toFixed(2)
        ) + " EUR"
      );
    },

    total() {
      return (
        Number.parseFloat(
          (
            this.$store.state.package.price +
            this.$store.state.rate * this.$store.state.freezing
          ).toFixed(2)
        ) + " EUR"
      );
    },

    budget: {
      get() {
        return this.$store.state.budget;
      },
      set(val) {
        const num = Number.parseFloat(val);
        this.$store.commit("setBudget", isNaN(num) ? 0 : num);
      },
    },

    license: {
      get() {
        return { code: this.$store.getters.license };
      },
      set(val) {
        const index = this.$store.getters.licenseAll.findIndex(
          (i) => i.code === val.code
        );
        this.$store.commit("setPackage", this.$store.state.packageAll[index]);
      },
    },

    startCourse: {
      get() {
        return { code: this.$store.state.startCourse };
      },
      set(val) {
        this.$store.commit("setStartCourse", val.code);
      },
    },

    endCourse: {
      get() {
        // return { code: this.$store.state.endCourse }
        return this.$store.state.endCourse;
      },
      set(val) {
        // this.$store.commit('setEndCourse', val.code)
        this.$store.commit("setEndCourse", val);
      },
    },

    availableMaxLoad: {
      get() {
        return { code: this.$store.getters.availableMaxLoad };
      },
      set(val) {
        const index = this.$store.getters.availableMaxLoadAll.findIndex(
          (i) => i.code === val.code
        );
        this.$store.commit("setPackage", this.$store.state.packageAll[index]);
      },
    },

    freezeMonth: {
      get() {
        return { code: this.$store.state.freezeMonth };
      },
      set(val) {
        this.$store.commit("setFreezeMonth", val.code);
      },
    },
    freezeMonthAll() {
      return this.$store.state.freezeMonthAll.map((i) => {
        const d1 = new Date(i.effectiveAt);
        const d2 = new Date(i.expiredAt);
        const part1 =
          ("0" + d1.getUTCDate()).slice(-2) +
          " - " +
          ("0" + d2.getUTCDate()).slice(-2);
        const part2 = d2.toLocaleString(this.$i18n.locale, {
          month: "short",
          year: "numeric",
          timeZone: "UTC",
        });
        return { ...i, label: part1 + " " + part2 };
      });
    },

    freezing: {
      get() {
        return this.$store.state.freezing;
      },
      set(val) {
        this.$store.commit("setFreezing", val);
      },
    },

    mintingCalendar() {
      return this.$store.getters.mintingCalendar;
    },
  },
  mounted() {
    this.$store.commit("setFreezing", this.availableMaxLoad.code);
  },
  watch: {
    // availableMaxLoad() {
    //   this.$store.commit('setFreezing', this.availableMaxLoad.code)
    // }
  },
};
</script>

<style lang="scss" scoped>
.calcFilter {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 -15px 50px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;

  @media (min-width: $breakpoint-md) {
    padding: 24px;
  }

  @media (min-width: $breakpoint-xl) {
    padding: 32px;
  }

  &__section {
    & + & {
      margin-top: 24px;
    }
  }
}

.calcFilterForm {
  display: grid;
  gap: 8px;

  @media (min-width: $breakpoint-xl) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  &__formGroup {
    grid-column: 1/-1;

    &--auto {
      grid-column: auto;
    }

    &--slider {
      margin: 8px 0 16px;
    }
  }
}

.freezing {
  ::v-deep .plc-field__label {
    margin-bottom: 0;
  }

  &__value {
    @include text-subtitle-1;

    margin-bottom: 4px;
    text-align: right;
  }
}

.calcFilterIncome {
  background: url("~img/bg-u.svg") no-repeat right;
  background-size: auto 100%;
  border: 4px solid $color-quartriary;
  border-radius: $border-radius * 2;
  box-shadow: 4px 4px 12px rgba(7, 55, 255, 0.04);
  padding: 16px;

  @media (min-width: $breakpoint-xl) {
    padding: 24px 16px;
  }

  &__delimiter {
    @media (min-width: $breakpoint-xl) {
      display: none;
    }
  }

  &__title {
    @include text-subtitle-1;

    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;

    @media (min-width: $breakpoint-md) {
      margin-bottom: 8px;
    }
  }

  &__row {
    @include text-subtitle-2;

    display: flex;
  }
}

.vue-range-slider {
  padding: 0 !important;

  ::v-deep .slider {
    background: rgba(0, 0, 0, 0.05) !important;
    border-radius: $border-radius !important;

    .slider-process {
      background: rgba(13, 91, 219, 0.24);
    }

    .slider-dot-handle {
      background: $color-primary !important;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24) !important;
    }
  }
}
</style>
